// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilGrayXDark":"#57595D","easilGrayXLight":"#D1D4D6","wrapper":"style_wrapper__229wG"};